import React from 'react'
import { BarChart, Bar, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { useRecoilValue } from 'recoil'
import { analyticData } from '../../../recoil/analytic'

const QuizChart = () => {
  const analytic = useRecoilValue(analyticData);
  
  const data = analytic.graph_data.map(item => {
    return { num: item.num, Benar: item.correct, Salah: item.wrong };
  })
  
  return (
    <div className='w-full h-96'>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3"/>
          <XAxis dataKey="num"/>
          <YAxis/>
          <Tooltip/>
          <Legend/>
          <Bar dataKey="Benar" fill="#34d399"/>
          <Bar dataKey="Salah" fill="#f87171"/>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default QuizChart